export default __webpack_public_path__ + "static/media/ie.7c3e6056.jpg";